<form class="flex flex-col gap-3" [formGroup]="form" (submit)="submit()">
  <app-timezone-input
    testId="schedule-add-available-times-timezone"
    required
    [(timezone)]="timezoneName"
  />
  <div class="flex flex-col gap-1" formGroupName="date">
    <div class="grid grid-cols-2 grid-rows-1 gap-2">
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label data-test-id="schedule-add-available-times-date-start-label">
          From
        </mat-label>
        <input
          matInput
          type="date"
          formControlName="start"
          data-test-id="schedule-add-available-times-date-start"
          [errorStateMatcher]="rangeErrorStateMatcher"
          [min]="minDate()"
          [max]="maxDate()"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label data-test-id="schedule-add-available-times-date-end-label">
          To
        </mat-label>
        <input
          matInput
          type="date"
          formControlName="end"
          data-test-id="schedule-add-available-times-date-end"
          [errorStateMatcher]="rangeErrorStateMatcher"
          [min]="minDate()"
          [max]="maxDate()"
        />
      </mat-form-field>
    </div>
    @let dateRangeError = getDateRangeError();
    @if (dateRangeError) {
      <mat-error
        class="form-error inset"
        data-test-id="schedule-add-available-times-date-error"
      >
        {{ dateRangeError }}
      </mat-error>
    }
  </div>
  <div class="flex flex-col gap-1">
    <div class="section-caption flex flex-row justify-between">
      <p data-test-id="schedule-add-available-times-days-label">Repeat on</p>
      <button
        class="link-button"
        type="button"
        data-test-id="schedule-add-available-times-weekdays-button"
        (click)="selectAllWeekdays()"
      >
        Weekdays
      </button>
    </div>
    <mat-chip-listbox
      multiple
      formControlName="days"
      aria-label="Repeat on"
      data-test-id="schedule-add-available-times-days"
    >
      @for (day of daysOfWeek(); track day) {
        <mat-chip-option
          data-test-id="schedule-add-available-times-days-option"
          [value]="$index"
        >
          {{ day }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
    @let daysError = getDaysError();
    @if (daysError) {
      <mat-error
        class="form-error"
        data-test-id="schedule-add-available-times-days-error"
      >
        {{ daysError }}
      </mat-error>
    }
  </div>
  <app-schedule-times-fields [controls]="form.controls">
    @let pastTimesError = getPastTimesError();
    @if (pastTimesError) {
      <mat-error
        class="form-error inset"
        data-test-id="schedule-add-available-times-past-error"
      >
        {{ pastTimesError }}
      </mat-error>
    }
    @let skippedTimesError = getSkippedTimesError();
    @if (skippedTimesError) {
      <mat-error
        class="form-error inset"
        data-test-id="schedule-add-available-times-skipped-error"
      >
        {{ skippedTimesError }}
      </mat-error>
    }
  </app-schedule-times-fields>

  <button
    class="submit-button"
    mat-flat-button
    type="button"
    color="primary"
    data-test-id="schedule-add-available-times-submit-button"
    [disabled]="disabled()"
    (click)="submit()"
  >
    <mat-icon>add</mat-icon>
    {{ submitLabel() }}
  </button>
</form>
